export const initialState = {
  list: [],
  isLoading: false,
  error: null,
};
